module.exports = __webpack_public_path__ + "img/violet_024.4c047d6d.png";